// extracted by mini-css-extract-plugin
export default {"even":"style_even__vFts0","odd":"style_odd__7caIp"};